import { List, ListItem, type ListProps as ChakraListProps, type ChakraProps } from "@chakra-ui/react";
import React, { type ReactNode } from "react";

type ListProps = {
  items: string[] | ReactNode[];
  bulletColor?: ChakraProps["color"];
} & ChakraListProps;

export function Bullets({ items, bulletColor = "text.primary", ...props }: ListProps) {
  return (
    <List spacing="smallest" listStyleType="disc" {...props}>
      {items.map((item, i) => (
        <ListItem key={i}>{item}</ListItem>
      ))}
    </List>
  );
}
